import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface ActiveWorkspaceState {
  workspace_id: string | null;
  setWorkspaceId: (id: string | null) => void;
}

export const useActiveWorkspaceStore = create<ActiveWorkspaceState>()(
  persist(
    (set) => ({
      workspace_id: null,
      setWorkspaceId: (id) => set({ workspace_id: id })
    }),
    { name: 'zaptor:active_workspace_id' }
  )
);
